import SportCourtShell from "../../shared/SportCourtShell";
import {
  LandscapePickleballCourtSvg,
  PortraitPickleballCourtSvg,
} from "../assets/PickleballCourtSvgs";
import { SPORT_IDS } from "../../../domain/sport/sportTypes";
import s from "./pickleballCourt.module.css";

/**
 * Pickleball court renderer — shared interaction shell + sport SVG.
 * Kitchen label is HTML (not SVG text) so it stays unstretched when the court fills.
 */
export default function PickleballCourt(props) {
  return (
    <SportCourtShell
      {...props}
      sportId={SPORT_IDS.PICKLEBALL}
      courtPresentationId="pickleball.court.v1"
      PortraitSvg={PortraitPickleballCourtSvg}
      LandscapeSvg={LandscapePickleballCourtSvg}
      stageExtras={
        <p className={s.kitchenLabel} aria-hidden>
          Kitchen
        </p>
      }
    />
  );
}
